import { useQuery } from '@tanstack/react-query';
import { surchargesQueryKeys, getSurcharge } from '../api/surcharges';
import type { SurchargeResponse } from '../api/surcharges';

const STALE_TIME = 30_000;

interface UseSurchargeOptions {
  initialData?: SurchargeResponse;
  enabled?: boolean;
}

export function useSurcharge(id: number, { initialData, enabled = true }: UseSurchargeOptions = {}) {
  return useQuery({
    queryKey: surchargesQueryKeys.detail(id),
    queryFn: () => getSurcharge(id),
    staleTime: STALE_TIME,
    enabled,
    ...(initialData ? { initialData, initialDataUpdatedAt: Date.now() } : {}),
  });
}
